import { useCertificates } from "@/hooks/useLearning";
import LoadingState from "../components/LoadingState";
import ErrorState from "../components/ErrorState";

export default function Sertifikalar() {
  const { data: certificates, loading, error, reload } = useCertificates();

  if (loading) return <LoadingState />;
  if (error) return <ErrorState message={error} onRetry={reload} />;

  const list = certificates ?? [];

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 tracking-tight">Sertifikalarım</h1>
          <p className="text-sm md:text-base text-foreground-600 mt-1">
            Kazandığın başarı sertifikaları ve rozetler.
          </p>
        </div>
        <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-sm font-semibold whitespace-nowrap">
          <i className="ri-award-line" aria-hidden="true"></i>
          {list.length} başarı
        </span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
        {list.map((cert) => (
          <div
            key={cert.id}
            className="bg-background-50 rounded-xl border border-background-200 p-6 flex flex-col items-center text-center hover:border-accent-300 transition-colors"
          >
            <span className={`w-16 h-16 flex items-center justify-center rounded-full ${cert.color}`}>
              <i className={`${cert.icon} text-3xl`} aria-hidden="true"></i>
            </span>
            <h3 className="mt-4 font-heading font-semibold text-base text-foreground-950">{cert.title}</h3>
            <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{cert.description}</p>
            <p className="mt-3 text-xs text-foreground-400">{cert.date}</p>
          </div>
        ))}
      </div>
    </div>
  );
}